import { render, staticRenderFns } from "./MatchProblem.vue.js?vue&type=template&id=1d5e8a29&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MatchProblem.vue?vue&type=template&id=1d5e8a29&scoped=true"
import script from "./MatchProblem.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MatchProblem.vue?vue&type=script&lang=js"
export * from "./MatchProblem.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MatchProblem.vue?vue&type=script&lang=js"
import style0 from "./MatchProblem.vue.css?vue&type=style&index=0&id=1d5e8a29&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MatchProblem.vue?vue&type=style&index=0&id=1d5e8a29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e8a29",
  null
  
)

export default component.exports